export default {
  color: 'brand',
  pad: {
    horizontal: 'medium'
  },
  margin: 'none',
  border: undefined
}
